export default __webpack_public_path__ + "static/media/bmi.730ead0a.gif";